import { FC, PropsWithChildren } from 'react'

type PlaceholderProps = PropsWithChildren<{
  width?: number
  height?: number
  testId?: string
  className?: string
}>

const Placeholder: FC<PlaceholderProps> = ({
  width,
  height,
  testId,
  children,
  className,
}) => {
  return (
    <div
      style={{ width: width && `${width}px`, height: height && `${height}px` }}
      data-testid={testId}
      className={className}
    >
      {children}
    </div>
  )
}

export default Placeholder
